module.exports = __webpack_public_path__ + "92022e1c9c328d97272806951f601c35.MP3";